export default __webpack_public_path__ + "static/media/Background-mobile.38645f7b.jpg";